module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "reports traccar_wrp"
  }, [(_vm.popupShow) ? _c('div', {
    staticClass: "popup-overlay"
  }, [_c('div', {
    staticClass: "popup-container"
  }, [_c('div', {
    staticClass: "popup-content"
  }, [_c('div', {
    staticClass: "overlay waste_type_pop",
    attrs: {
      "id": "details"
    }
  }, [_c('div', {
    staticClass: "overlay_inner"
  }, [_c('div', {
    staticClass: "row form-modal popup_modal rounded"
  }, [_vm._m(0), _vm._v(" "), _c('h3', {
    staticClass: "popup-titles"
  }, [_vm._v("Warning!")]), _vm._v(" "), _c('p', {
    staticClass: "popup-message"
  }, [_vm._v("There is no trip associated.")]), _vm._v(" "), _c('div', {
    staticClass: "form-actions dismiss"
  }, [_c('button', {
    staticClass: "popup-dismiss",
    on: {
      "click": _vm.onModalClose
    }
  }, [_vm._v("Close")])])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.lineStatusPopUP) ? _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "overlay_inner"
  }, [_c('div', {
    staticClass: "form-modal"
  }, [_c('h4', [_vm._v("Update Line Status")]), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('button', {
    class: 'mr-2 btn gradientbt',
    on: {
      "click": function($event) {
        return _vm.selectAll()
      }
    }
  }, [_vm._v("Mark All")]), _vm._v(" "), _c('vue-form', {
    staticClass: "formadd_scroll",
    attrs: {
      "state": _vm.formstate
    }
  }, [_c('div', {
    staticClass: "houses_wrp"
  }, _vm._l((_vm.filteredLineStatusArray), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "flex house_number_wrp"
    }, [_c('div', {
      staticClass: "house_number_boxs"
    }, [_c('h5', [_vm._v("Line Number " + _vm._s(item.lineNumber))])]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.status),
        expression: "item.status"
      }],
      staticStyle: {
        "margin-left": "10px"
      },
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(item.status) ? _vm._i(item.status, null) > -1 : (item.status)
      },
      on: {
        "change": [function($event) {
          var $$a = item.status,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(item, "status", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(item, "status", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(item, "status", $$c)
          }
        }, function($event) {
          return _vm.onCheckboxChange(item)
        }]
      }
    })])
  }), 0)]), _vm._v(" "), _c('button', {
    class: 'mr-5  btn btn-default',
    on: {
      "click": function($event) {
        return _vm.onClose()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    class: 'mr-2 btn gradientbt',
    on: {
      "click": _vm.updateLineStatus
    }
  }, [_vm._v("Submit")])], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.loadings) ? _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader'), _vm._v(" "), _c('p', [_vm._v("Please Wait...")])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "monitoring_wrp"
  }, [_c('div', {
    staticClass: "col-md-12 city_dropdown"
  }, [_c('div'), _vm._v(" "), ((this.$store.state.auth.user.role.key === 'superAdmin' ||
    this.$store.state.auth.user.role.key === 'cityAdmin' ||
    this.$store.state.auth.user.role.key === 'subCityAdmin') && _vm.selectedRow) ? _c('button', {
    staticClass: "btn gradientbt mark",
    attrs: {
      "disabled": _vm.selectedRow.percentages == 100
    },
    on: {
      "click": _vm.falseStatusLineList
    }
  }, [_vm._v("\n        Mark Line complete\n      ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn gradientbt",
    on: {
      "click": _vm.refreshReportList
    }
  }, [_vm._v("Refresh")])]), _vm._v(" "), _c('div', {
    staticClass: "row pd-10"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "dates_left_wrp pd-0"
  }, [_c('div', {
    staticClass: "dates_left new_dates_left pd-10 margin-0"
  }, [_c('label', [_vm._v("Zone")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "id": "startDate",
      "lang": "en",
      "name": "startDate",
      "not-after": _vm.disabledStartDate,
      "clearable": false,
      "required": "",
      "input-class": "form-control",
      "width": "100%",
      "valueType": "format",
      "format": 'DD-MM-YYYY',
      "placeholder": "Date Filter"
    },
    on: {
      "input": _vm.startDate
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "scroll-items row margin-0"
  }, [_c('div', {
    staticClass: "details-card"
  }, [_c('div', {
    staticClass: "collection_divisions_table zoneDetails"
  }, [_c('table', [_vm._m(1), _vm._v(" "), _vm._l((_vm.datas), function(item, index) {
    return _c('tr', {
      key: index,
      class: {
        'selected-row': _vm.selectedRow === item
      },
      on: {
        "click": function($event) {
          return _vm.onRowClick(item)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(item.areaName))]), _vm._v(" "), _c('td', [_c('progress', {
      staticClass: "progressContainer",
      attrs: {
        "max": "100"
      },
      domProps: {
        "value": item.percentages
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "progressReference"
    }, [_vm._v(_vm._s(item.percentages) + " %")])])])
  })], 2)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 pd-0"
  }, [_c('div', {
    staticClass: "map-view"
  }, [_c('traccarMonitoringMapBeta', {
    key: _vm.refreshKey
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "trip_details route_tracking_trip_details"
  }, [_c('div', {}, [_c('div', {
    staticClass: "zone_cart_wrp",
    staticStyle: {
      "overflow-y": "auto",
      "height": "calc(100vh - 42vh)"
    }
  }, [_c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Zone")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.details.zoneName ? _vm.details.zoneName : "--"))])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Vehicle No")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.details.vehicleId ? _vm.details.vehicleId.vNumber : "--"))])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Device Status")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.deviceStatus !== undefined ? _vm.deviceStatus.status : "--"))])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Trip Status")]), _vm._v(" "), _c('p', {
    class: _vm.details.tripStatus
  }, [_vm._v(_vm._s(_vm.details.tripStatus ? _vm.details.tripStatus : "--"))])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Trip Schedule")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.details.scheduleTime ? _vm.details.scheduleTime : "--"))])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Trip Start Time")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.details.startTime ? _vm.details.startTime : "--"))])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Trip End Time")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.details.endTime ? _vm.details.endTime : "--"))])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Driver Name")]), _vm._v(" "), _c('p', [_vm._v("\n                  " + _vm._s(_vm.details.driverFirstName ?
    _vm.details.driverFirstName + " " + _vm.details.driverLastName :
    "--") + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Driver Contact Number")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.details.driverContactName ? _vm.details.driverContactName : "--"))])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Helper Name")]), _vm._v(" "), _c('p', [_vm._v("\n                  " + _vm._s(_vm.details.helperFirstName ?
    _vm.details.helperFirstName + " " + _vm.details.helperLastName :
    "--") + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Helper Contact Number")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.details.helperContactName ? _vm.details.helperContactName : "--"))])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Total Lines")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.details.totalLines !== null ? _vm.details.totalLines : "--"))])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Completed Lines")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.details.completedLines !== null ? _vm.details.completedLines : "--"))])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Skipped Lines")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.details.totalLines !== null ? _vm.details.totalLines - _vm.details.completedLines : "--"))])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Total Covered Distance [In Zone]")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.details.tracarrDistInZone !== null ? _vm.details.tracarrDistInZone : "--"))])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Total Covered Distance")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.details.tracarrDistance !== null ? _vm.details.tracarrDistance : "--"))])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Total Time(Hrs)")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.details.totalTimes !== null ? _vm.details.totalTimes : "--"))])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Total Time [In Zone]")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.details.TracarrTimeInZone !== null ? _vm.details.TracarrTimeInZone : "--"))])])]), _vm._v(" "), _c('div', {
    staticClass: "zone_cart_wrp driver_zone_wrp"
  })])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "iconMina"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle",
    staticStyle: {
      "font-size": "48px",
      "color": "white"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Zone")]), _vm._v(" "), _c('th', [_vm._v("Percentage")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dates_left_wrp pd-0"
  }, [_c('div', {
    staticClass: "dates_left new_dates_left pd-10 margin-0"
  }, [_c('label', [_vm._v("Trip Details")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c0febe46"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/location-tracking/traccarMonitoringBeta.vue
// module id = 2390
// module chunks = 1